/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvestmentBreakdown
 */
export interface InvestmentBreakdown {
    /**
     * 
     * @type {string}
     * @memberof InvestmentBreakdown
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentBreakdown
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvestmentBreakdown
     */
    roles: Array<string>;
}

/**
 * Check if a given object implements the InvestmentBreakdown interface.
 */
export function instanceOfInvestmentBreakdown(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "number" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "roles" in value;

    return isInstance;
}

export function InvestmentBreakdownFromJSON(json: any): InvestmentBreakdown {
    return InvestmentBreakdownFromJSONTyped(json, false);
}

export function InvestmentBreakdownFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentBreakdown {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'number': json['Number'],
        'name': json['Name'],
        'roles': json['Roles'],
    };
}

export function InvestmentBreakdownToJSON(value?: InvestmentBreakdown | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Number': value.number,
        'Name': value.name,
        'Roles': value.roles,
    };
}

